import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class AdminProductForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      variant: [ '', Validators.required ],
      aspectRatio: [ '', Validators.required ],
      name: [ '', Validators.required ],
      description: [ '', Validators.required ],
      image: [ '', Validators.required ],
      orderNumber: [ null, Validators.required ],
      type: [ '', Validators.required ],
      language: [ '' ],
    });
  }
}
